module.exports = __webpack_public_path__ + "static/media/8bit-github.6ccb318f.png";